import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { errorActionClass } from '@/shared/components/gameErrorActions'
import { ErrorTitleHighlight, GameErrorPage } from '@/shared/components/GameErrorPage'
import { SeoHead } from '@/shared/components/SeoHead'
import type { PageHead } from '@/shared/seo/head'

/**
 * 404 de la app (ruta `*`, guard de admin, landings sin datos): la carta «perdida»
 * (`GameErrorPage`). Sin JS, el mismo texto lo inyecta la Pages Function en sus 404
 * (`shared/seo/edge/handleEdgeRequest`).
 */
export default function NotFoundPage({ head }: { head?: PageHead }) {
  const { t } = useTranslation()
  return (
    <>
      {/* `head`: el caller que tiene su propio 404 (landings) lo pasa; si no, el genérico. */}
      <SeoHead
        {...(head ?? {
          title: t('errorPage.notFound.metaTitle'),
          description: t('errorPage.notFound.lead'),
          noindex: true,
          jsonLd: [],
        })}
      />
      <GameErrorPage
        kind="notFound"
        eyebrow={t('errorPage.notFound.eyebrow')}
        title={
          <Trans i18nKey="errorPage.notFound.title" components={{ hl: <ErrorTitleHighlight /> }} />
        }
        lead={t('errorPage.notFound.lead')}
        card={{
          title: t('errorPage.notFound.cardTitle'),
          effectLabel: t('errorPage.cardEffectLabel'),
          effect: t('errorPage.notFound.cardEffect'),
          flavor: t('errorPage.notFound.cardFlavor'),
          back: t('errorPage.cardBack'),
        }}
        actions={
          <>
            <Link to="/sessions" className={errorActionClass.primary}>
              {t('errorPage.notFound.primary')}
            </Link>
            <Link to="/" className={errorActionClass.secondary}>
              {t('errorPage.notFound.secondary')}
            </Link>
          </>
        }
      />
    </>
  )
}
